// extracted by mini-css-extract-plugin
export default {"container":"xj-z","links":"yj-z"};